import {css} from "lit";

export const annotationHighlightStyles = css`
	.annotation-list-item {
		position: relative;
		margin-top: 10px;
		padding: 10px;
		background-color: var(--pn-outline-annotation-bg-color);
		border: 1px solid var(--pn-outline-annotation-border-color);
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: block;
	}

	.annotation-list-item:hover, .annotation-list-item:focus, .annotation-list-item:focus-within {
		border-color: var(--pn-outline-annotation-border-color-hover);
		box-shadow: 0 2px 4px rgba(0,0,0,.5);
	}

	.annotation-list-item > * {
		transition: .2s opacity;
	}

	.text {
		margin: 6px 0 10px 0;
		padding: 0 0 0 6px;
		border-left: 2px solid var(--pn-outline-annotation-quote-border-left-color);
		color: var(--pn-outline-annotation-quote-text-color);
		font-family: 'Georgia', serif;
		font-size: var(--pn-font-size-base);
		line-height: 1.4;
		overflow-wrap: break-word;
	}

	.mode-sidebar-drag {
		cursor: grab;
	}

	.text {
		margin: 6px 0 10px 0;
		padding: 0 0 0 6px;
		border-left: 2px solid var(--pn-outline-annotation-quote-border-left-color);
		color: var(--pn-outline-annotation-quote-text-color);
		font-family: 'Georgia', serif;
		font-size: var(--pn-font-size-base);
		line-height: 1.4;
		overflow-wrap: break-word;
	}


`;
